<template>
  <div>
    <NotificationsList
      :notifications="notifications"
      :user="user"
      title="My Inbox"
      detailLink="/member/inbox"
      @filter="filter"
    ></NotificationsList>
  </div>
</template>
<script>
import NotificationsList from "@/components/NotificationsList.vue";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "InboxView",
  components: {
    NotificationsList
  },
  data: function() {
    return {};
  },
  methods: {
    ...mapActions({
      getMyInbox: "getMyInbox",
      setInboxFilter: "setInboxFilter"
    }),
    filter(search) {
      this.setInboxFilter(search);
    }
  },
  computed: {
    ...mapGetters({
      filtered: "filteredInbox"
    }),
    ...mapState({
      user: s => s.auth.user
    }),
    notifications: function() {
      let u = { user: this.user };
      return this.filtered.map(function(n) {
        return { ...n, ...u };
      });
    }
  },
  created: function() {
    this.getMyInbox();
  }
};
</script>
<style>
</style>
